import Vue from 'vue'
import Vuex from 'vuex'
import env from '../config/env'

Vue.use(Vuex)

const state = {
  user: [],
  token: null,
  screenHeight: 0,
  screenWidth: 0,
  isLoading: false,
  config: {},
  btnbottom: false,
  URLHost: env.apiUrl,
  URLBase: env.uiUrl,
  Keypublic: env.keyPublic,
  menu_data: [],
  TurnstileSiteKey: env.cloudfireSiteKey,
  TurnstileEnabled: env.cloudfireEnabled
}

const store = new Vuex.Store({
  state
})

export default store



// WEBPACK FOOTER //
// ./src/Vuex/index.js